module.exports = __webpack_public_path__ + "static/gem-card-in-hand-bg-7a5cd0590c1d2e49d5e875c14a55696e.jpg";